/**
 * Kynd CRO t141/t163/t622 — draft theme 202457448831 only.
 * Refreshes every .kynd-b2g2-progress from /cart.js (cart page + drawer).
 * Free ship tip: item_count >= 2 OR subtotal >= $50. B2G2 bar: 4 eligible.
 */
(function () {
  var ROOT_SEL = '.kynd-b2g2-progress';
  var PROGRESS = [
    'Add Bracelets, Rings, or Necklaces to unlock Buy 2 Get 2.',
    '1 of 4 toward Buy 2 Get 2 — add 3 more eligible pieces.',
    '2 of 4 — add 2 more; the 2 lowest-priced will be free.',
    '3 of 4 — add 1 more to unlock Buy 2 Get 2.',
    'Buy 2 Get 2 applied — 2 lowest-priced eligible pieces free.',
  ];

  function moneyFromCents(cents) {
    return (Math.max(0, cents) / 100).toFixed(2);
  }

  function eligibleQty(cart, types) {
    var set = {};
    types.forEach(function (t) { set[t.toLowerCase()] = true; });
    var n = 0;
    (cart.items || []).forEach(function (item) {
      if (isGiftPackaging(item)) return;
      var pt = (item.product_type || '').toLowerCase();
      var title = (item.product_title || item.title || '').toLowerCase();
      if (set[pt]) {
        n += item.quantity || 0;
        return;
      }
      // Fallback: ring/bracelet/necklace in title when product_type empty/mismatched
      if (/ring|bracelet|necklace/.test(pt) || /ring|bracelet|necklace/.test(title)) {
        n += item.quantity || 0;
      }
    });
    return n;
  }

  function isGiftPackaging(item) {
    var pt = (item.product_type || '').toLowerCase();
    if (pt === 'gift packaging') return true;
    var title = (item.product_title || item.title || '').toLowerCase();
    return title.indexOf('signature gift box') !== -1;
  }

  function itemCount(cart) {
    // Exclude gift packaging so complimentary/extra sets do not unlock free shipping
    return (cart.items || []).reduce(function (n, i) {
      if (isGiftPackaging(i)) return n;
      return n + (i.quantity || 0);
    }, 0);
  }

  function shipCopy(cart, thresholdCents, freeShipQty) {
    var sub = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var qty = itemCount(cart);
    if (sub >= thresholdCents || qty >= freeShipQty) return 'Free shipping unlocked.';
    var needMoney = thresholdCents - sub;
    var needPcs = freeShipQty - qty;
    if (needPcs === 1 && needMoney > 0) {
      return '1 more piece for free shipping — or add $' + moneyFromCents(needMoney) + '.';
    }
    if (needPcs > 0 && needPcs < freeShipQty) {
      return needPcs + ' more pieces for free shipping — or add $' + moneyFromCents(needMoney) + '.';
    }
    return '$' + moneyFromCents(needMoney) + ' away from free shipping — or add ' + needPcs + ' more piece' + (needPcs === 1 ? '' : 's') + '.';
  }

  function renderRoot(root, cart) {
    var types = (root.getAttribute('data-eligible-types') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    var threshold = parseInt(root.getAttribute('data-threshold-cents') || '5000', 10);
    var freeShipQty = parseInt(root.getAttribute('data-freeship-qty') || '2', 10);
    var count = itemCount(cart);
    var qty = eligibleQty(cart, types);
    var capped = Math.min(qty, 4);
    var progressEl = root.querySelector('[data-role="progress-text"]');
    var shipEl = root.querySelector('[data-role="ship-text"]');
    var bar = root.querySelector('[data-role="bar"]');
    var fill = root.querySelector('[data-role="fill"]');

    root.removeAttribute('hidden');
    root.hidden = false;
    root.style.display = '';

    if (count === 0) {
      if (progressEl) {
        progressEl.textContent =
          'Buy 2 Get 2 on Bracelets, Rings & Necklaces · Free shipping on 2+ pieces or $50+.';
      }
      if (shipEl) shipEl.textContent = '';
      if (bar) bar.setAttribute('aria-valuenow', '0');
      if (fill) fill.style.width = '0%';
      return;
    }

    if (progressEl) progressEl.textContent = PROGRESS[capped] || PROGRESS[4];
    if (shipEl) shipEl.textContent = shipCopy(cart, threshold, freeShipQty);
    if (bar) bar.setAttribute('aria-valuenow', String(capped));
    if (fill) fill.style.width = (capped / 4) * 100 + '%';
  }

  function render(cart) {
    document.querySelectorAll(ROOT_SEL).forEach(function (root) {
      renderRoot(root, cart);
    });
  }

  var timers = [];
  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }
  function refreshSoon() {
    timers.forEach(clearTimeout);
    timers = [50, 150, 400, 900, 1800].map(function (ms) {
      return setTimeout(refresh, ms);
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    refresh();
    refreshSoon();
  });

  ['cart:updated', 'cart:refresh', 'variant:add'].forEach(function (ev) {
    document.addEventListener(ev, refreshSoon);
  });
  document.addEventListener('shopify:section:load', refreshSoon);
  document.addEventListener('shopify:section:reorder', refreshSoon);

  // Dawn pub/sub
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshSoon);
    }
  } catch (e) {}
  try {
    if (window.Shopify && typeof window.Shopify.subscribe === 'function') {
      window.Shopify.subscribe('cart-update', refreshSoon);
    }
  } catch (e2) {}

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (
        t.closest(
          'cart-drawer, #cart-icon-bubble, .cart-count-bubble, [href="/cart"], .quantity__button, product-form form[action*="/cart/add"], [name="add"], .product-form__submit'
        )
      ) {
        refreshSoon();
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t) return;
      if (t.matches && (t.matches('[name="updates[]"], .quantity__input, quantity-input input') || t.name === 'updates[]')) {
        refreshSoon();
      }
    },
    true
  );

  // Watch cart-drawer open attribute/class
  onReady(function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      if (drawer.classList.contains('active') || drawer.hasAttribute('open') || drawer.getAttribute('aria-hidden') === 'false') {
        refreshSoon();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
  });

  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches(ROOT_SEL)) || (n.querySelector && n.querySelector(ROOT_SEL))) {
            refreshSoon();
            return;
          }
        }
      }
    });
    onReady(function () {
      obs.observe(document.documentElement, { childList: true, subtree: true });
    });
  }

  var _fetch = window.fetch;
  if (typeof _fetch === 'function' && !_fetch.__kyndB2g2Patched) {
    window.fetch = function () {
      var args = arguments;
      return _fetch.apply(this, args).then(function (res) {
        try {
          var url = String(args[0] && args[0].url ? args[0].url : args[0] || '');
          if (/cart\/(add|change|update|clear)/i.test(url) || /sections=/i.test(url) || /section_id=/i.test(url)) {
            refreshSoon();
          }
        } catch (err) {}
        return res;
      });
    };
    window.fetch.__kyndB2g2Patched = true;
  }

  // Expose for console QA
  window.__kyndB2g2Refresh = refreshSoon;
})();
